@if (getShowButton) {
  @if (!article.has_stock_notification) {
    <label
      class="btn btn-tertiary mb-0"
      placement="bottom"
      ngbTooltip="{{ 'SN_STOCK_NOTIFICATION_TOOLTIP' | translate }}"
      #stockTooltip
      placement="bottom"
      (click)="addToStockList()"
      >
      <i class="material-icons">notifications</i>
    </label>
  }
  @if (article.has_stock_notification) {
    <label
      class="btn btn-tertiary text-success mb-0"
      placement="bottom"
      ngbTooltip="{{ 'SN_REMOVE_FROM_STOCK_NOTIFICATION' | translate }}"
      placement="bottom"
      (click)="removeFromStockList()"
      >
      <i class="material-icons">notifications_active</i>
    </label>
  }
}
